import { Calendar, Columns3, FileText, GanttChart, Table2 } from "lucide-react";
export const viewModes = [
  { type: "TABLE", fr: "Tableau", en: "Table", icon: Table2 },
  { type: "KANBAN", fr: "Kanban", en: "Kanban", icon: Columns3 },
  { type: "CALENDAR", fr: "Calendrier", en: "Calendar", icon: Calendar },
  { type: "GANTT", fr: "Gantt", en: "Gantt", icon: GanttChart },
  { type: "DOCUMENT", fr: "Document", en: "Document", icon: FileText },
];
